const getPhoneNumberDigits = (number: string): string => {
	const stripped = number.replace(/[^\d]/g, "");
	if (stripped.startsWith("1")) {
		return stripped.replace("1", "");
	}
	return stripped;
};

export default getPhoneNumberDigits;
